import { useMutation } from '@tanstack/react-query';

import { TFormFile } from '@/utils/formFileList';

import { uploadFormFiles } from './file.service';
import { UPLOADED_FILES_SERVICE } from './uploaded-files-service';

import { CloudFileDto } from '@/generated-types';

type TUploadDocumentMutationResponse = ReturnType<
	typeof useMutation<CloudFileDto[] | null, unknown, TFormFile[]>
>;

export const useUploadDocument = (): TUploadDocumentMutationResponse => {
	const uploadFile = async (files: TFormFile[]): Promise<CloudFileDto[] | null> => {
		let uploadedFiles: CloudFileDto[] | null = null;

		const unloadedFiles = files?.filter((file) => !UPLOADED_FILES_SERVICE.hasFileId(file.uid));

		if (unloadedFiles?.length) {
			uploadedFiles = await uploadFormFiles(unloadedFiles);
		}

		return uploadedFiles;
	};

	const uploadDocumentMutation = useMutation({
		mutationKey: ['uploadDocument'],
		mutationFn: async (files: TFormFile[]) => uploadFile(files),
		onSuccess: (cloudFiles, variables) => {
			if (cloudFiles) {
				cloudFiles.forEach((file, index) => {
					UPLOADED_FILES_SERVICE.addFileId(variables[index].uid, file.id as string);
				});
			}
		},
	});

	return uploadDocumentMutation;
};
